var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07993 6.65039V6.66039C7.64893 6.66039 7.29993 7.01039 7.29993 7.44039C7.29993 7.87039 7.64893 8.22039 8.07993 8.22039H11.0689C11.4999 8.22039 11.8499 7.87039 11.8499 7.42939C11.8499 7.00039 11.4999 6.65039 11.0689 6.65039H8.07993ZM15.9199 12.7404H8.07993C7.64893 12.7404 7.29993 12.3904 7.29993 11.9604C7.29993 11.5304 7.64893 11.1794 8.07993 11.1794H15.9199C16.3499 11.1794 16.6999 11.5304 16.6999 11.9604C16.6999 12.3904 16.3499 12.7404 15.9199 12.7404ZM15.92 17.3104H8.07996C7.77996 17.3504 7.48996 17.2004 7.32996 16.9504C7.16996 16.6904 7.16996 16.3604 7.32996 16.1104C7.48996 15.8504 7.77996 15.7104 8.07996 15.7404H15.92C16.319 15.7804 16.62 16.1204 16.62 16.5304C16.62 16.9294 16.319 17.2704 15.92 17.3104Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLight);
export default __webpack_public_path__ + "static/media/file-light.dad97418ce7da92dcce3073a0433777c.svg";
export { ForwardRef as ReactComponent };